<template>
  <div class="checkDetails" v-loading="loading">
    <el-card style="margin-bottom:20px" shadow="never">
      <el-row>
        <h3>商户信息</h3>
        <el-table :data="tableData" border style="width:100%">
          <el-table-column
            fixed
            prop="fMerchantId"
            label="商户编号">
          </el-table-column>
          <el-table-column
            fixed
            prop="fMerchantName"
            label="商户简称">
          </el-table-column>
          <el-table-column
            fixed
            prop="fDirectlyAgentId"
            label="直属代理商">
          </el-table-column>
          <el-table-column
            fixed
            prop="fOperator"
            label="发展业务员">
          </el-table-column>
          <el-table-column
            fixed
            prop="fDealStateStr"
            label="交易状态">
          </el-table-column>
          <el-table-column
            fixed
            prop="fSettleStateStr"
            label="结算状态">
          </el-table-column>
          <el-table-column
            fixed
            prop="fCreateTime"
            label="接收时间">
          </el-table-column>
          <el-table-column
            fixed
            prop="fTicketNumber"
            label="工单号">
          </el-table-column>
          <el-table-column
            fixed
            prop="auditStatus"
            label="处理状态">
            <template slot-scope="scope">
              <span v-if="scope.row.auditStatus === 1" class="red">待提交</span>
              <span v-if="scope.row.auditStatus === 2">审核中</span>
              <span v-if="scope.row.auditStatus === 3" class="red">审核未通过</span>
              <span v-if="scope.row.auditStatus === 4" class="green">审核通过</span>
              <span v-if="scope.row.auditStatus === 5" class="red">审核终止</span>
            </template>
          </el-table-column>
        </el-table>
        <h3>风险详情</h3>
        <div class="marginLeft">
          <p class="content">风险来源：{{ fRiskSourceStr }}</p>
          <p class="content">风险类型：{{ form.fRiskTypeStr }}</p>
          <p class="content">风险等级：<span v-if="form.fRiskLevel">{{ form.fRiskLevel }}</span><span v-else>--</span></p>
        </div>
        <h3 v-if="form.fProhibitSettlReason">禁止原因</h3>
        <div class="marginLeft">
          <!--                <p>{{fProhibitSettlTypeStr}}</p>-->
          <!--                <p>禁止原因：<br>{{form.fProhibitSettlReason}}</p>-->
          <p class="content">{{ form.fProhibitSettlReason }}</p>
        </div>
        <div class="border"></div>
        <h3>申诉记录</h3>
        <div class="recordList">
          <el-table :show-header="false" :data="form.fFlowList" style="width: 800px;">
            <el-table-column
              fixed
              prop="fCreateTime"
              width="180">
            </el-table-column>
            <el-table-column
              fixed
              prop="auditStatus"
              width="150">
              <template slot-scope="scope">
                <span v-if="scope.row.auditStatus === 1">待提交</span>
                <span v-if="scope.row.auditStatus === 2">审核中</span>
                <span v-if="scope.row.auditStatus === 3">审核未通过</span>
                <span v-if="scope.row.auditStatus === 4">审核通过</span>
                <span v-if="scope.row.auditStatus === 5">审核终止</span>
              </template>
            </el-table-column>
            <el-table-column
              fixed
              prop="fOperator"
              min-width="150">
              <template slot-scope="scope">
                <!--                            <span v-if="scope.row.fOperator && scope.row.fMtlVerifyStatus !== 3">操作人：{{scope.row.fOperator}}</span>-->
                <span v-if="scope.row.fUnpassReason!=='' && scope.row.auditStatus === 3">原因：{{ scope.row.fUnpassReason }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-button disabled v-if="form.auditStatus !== 1 && form.auditStatus !== 3" class="marginTop">已提交</el-button>
        <div class="marginTop" v-else>
          <auth-button opt="online_appeal" @click.native="toOnlineAppeal" label="在线申诉"></auth-button>
          <auth-button opt="artificial_appeal" @click.native="toArtificialAppeal" label="人工申诉"></auth-button>
        </div>
      </el-row>
    </el-card>

    <!--        微信支付宝在线申诉-->
    <online-wechat-alipay v-if="onlineDialogVisible" :visible.sync="onlineDialogVisible" :row="form" @closeOnline="closeOnline" @success="wechatAlipayOnline"></online-wechat-alipay>
    <!--        乐刷、云闪付、微信投诉人工申诉弹窗-->
    <artificial-appeal v-if="artificialDialogVisible" :visible="artificialDialogVisible" :row="form" @closeArtificial="closeArtificial" @toOnline="toOnlineAppeal"></artificial-appeal>
    <!--        乐刷、云闪付、微信投诉申诉弹窗-->
    <other-form v-if="otherAppealDialogVisible" :visible.sync="otherAppealDialogVisible" :requestForm="otherAppealForm" @submit="submitSuccess"></other-form>
    <!--        微信、支付宝风控人工申诉弹窗-->
    <artificial-wechat-alipay v-if="artificialDialogVisible2" :row="form" :visible="artificialDialogVisible2" @toOnline="toOnlineAppeal" @closeArtificial="closeArtificial2"></artificial-wechat-alipay>
    <!--        微信不通过仅乐刷解冻在线申诉-->
    <unfreeze-form v-if="unfreezeDialogVisible" :visible.sync="unfreezeDialogVisible" :requestForm="otherAppealForm" @submit="submitSuccess"></unfreeze-form>
  </div>
</template>

<script>
import qs from 'qs'
import onlineWechatAlipay from './components/onlineWechatAlipay'
import artificialAppeal from './components/artificialAppeal'
import artificialWechatAlipay from './components/artificialWechatAlipay'
import otherForm from './components/otherForm'
import unfreezeForm from './components/unfreezeForm'
import { riskTicketsDetail } from '@/api/risk'
import { parseAuditStatus } from '@/utils/parseData'
export default {
  name: 'CheckDetails',
  components: {
    onlineWechatAlipay,
    artificialAppeal,
    artificialWechatAlipay,
    otherForm,
    unfreezeForm
  },
  data () {
    return {
      dialogVisible: this.visible,
      tableData: [],
      artificialDialogVisible: false,
      form: {},
      otherAppealDialogVisible: false,
      otherAppealForm: {},
      loading: false,
      artificialDialogVisible2: false,
      unfreezeDialogVisible: false,
      onlineDialogVisible: false,
      submitLoading: false// 触发接口按钮加载
    }
  },
  computed: {
    fRiskSourceStr () {
      switch (this.form.fRiskSource) {
        case 1: {
          return '微信投诉'
        }
        case 2: {
          return '微信违规'
        }
        case 3: {
          return '支付宝违规'
        }
        case 4: {
          return '云闪付'
        }
        case 6: {
          return '支付宝告警'
        }
        default: {
          return '乐刷'
        }
      }
    },
    fProhibitSettlTypeStr () {
      switch (this.form.fProhibitSettlType) {
        case 1: {
          return '禁止部分金额结算'
        }
        case 2: {
          return '禁止T+1结算'
        }
        case 3: {
          return '禁止T+0结算'
        }
        case 4: {
          return '同时禁止T+1和T+0结算'
        }
        default: {
          return '不禁止任何结算'
        }
      }
    },
    // 申诉类型，微信或支付宝，fAppealInfoType等于3是支付宝，2是微信，4是微信不通过,乐刷解冻
    fAppealInfoTypeText () {
      return this.form.fAppealInfoType === 3 ? '支付宝' : '微信'
    }
  },
  watch: {
    visible (value) {
      this.dialogVisible = value
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    async initData () {
      this.loading = true
      await this.getDetails()
      this.loading = false
    },
    /**
             * @description 获取详情数据
             */
    getDetails () {
      var id = this.$route.path.split('/')[4]
      var data = {
        ticketNumber: id
      }
      this.tableData = []
      var that = this
      data = qs.stringify(data)
      return new Promise((resolve, reject) => {
        riskTicketsDetail(data).then(data => {
          if (parseInt(data.error_code) !== 0) {
            this.$message({
              showClose: true,
              message: data.error_msg,
              type: 'error'
            })
            resolve(false)
          } else {
            //    赋值给agentForm
            if (data.data) {
              data.data.auditStatus = parseAuditStatus(data.data.fTicketStatus, data.data.fMtlVerifyStatus)
              data.data.fFlowList = data.data.fFlowList.map(item => {
                item.auditStatus = parseAuditStatus(data.data.fTicketStatus, item.fMtlVerifyStatus)
                return item
              })
              that.form = data.data
              this.tableData.push(this.form)
            }
            resolve()
          }
        })
      })
    },
    /**
             * @description 在线申诉
             */
    toOnlineAppeal () {
      if (this.form.fAppealInfoType === 1 || this.form.fAppealInfoType === 6) {
        this.otherAppealForm = {
          id: this.$route.path.split('/')[3],
          ticketNumber: this.form.fTicketNumber,
          merchantId: this.form.fMerchantId,
          appealInfoType: this.form.fAppealInfoType
        }
        this.otherAppealDialogVisible = true
      } else {
        this.closeArtificial2()
        this.onlineDialogVisible = true
      }
    },
    /**
             * @description 人工申诉
             */
    toArtificialAppeal () {
      this.artificialDialogVisible = true
    },
    /**
             * @description 关闭人工申诉弹窗
             */
    closeArtificial (value) {
      this.artificialDialogVisible = value
      //    刷新弹窗数据
    },
    /**
             * 关闭微信、支付宝人工申诉弹窗
             */
    closeArtificial2 (value) {
      this.artificialDialogVisible2 = value
    },
    /**
             * @description 上传图片成功
             * @param  {object} data 上传成功接口返回数据及该数据对应属性名
             */
    uploadSuccess (data) {
      this[data.valueName] = data.path
    },
    /**
             * @description 提交模板表单成功
             */
    submitSuccess () {
      this.initData()
    },
    /**
             * 关闭微信、支付宝在线申诉弹窗
             */
    closeOnline (value) {
      this.onlineDialogVisible = value
    },
    /**
             * 微信、支付宝在线申诉弹窗提交成功
             */
    wechatAlipayOnline (value) {
      if (value.type === 'failed') {
        this.otherAppealForm = value.otherAppealForm
        this.unfreezeDialogVisible = true
      } else {
        this.initData()
      }
    }
  }
}
</script>

<style scoped>
    .checkDetails{
        padding-left: 16px;
    }
    .checkDetails h3{
        margin-top: 30px;
    }
    .checkDetails h3:first-child{
        margin-top: 0;
    }
    .checkDetails .marginLeft{
        margin-left: 20px;
    }
    .checkDetails .marginTop{
        margin-top: 20px;
    }
    .checkDetails .border{
        width: 100%;
        height: 1px;
        background: #dcdfe6;
    }
    .red{
        color: #ff7070;
    }
    .green{
        color: #77d580;
    }
    .tips{
        font-size: 14px;
        line-height: 20px;
        color: #999;
    }
    .marginBtm{
        margin-bottom: 30px;
    }
    h3 {
        margin-bottom:20px
    }
    .content{
        margin-bottom: 14px;
        font-size: 14px;
        color: "#606266";
    }
</style>
